export * from './app-footer.component';



// WEBPACK FOOTER //
// ./src/app/shared/app-footer/index.ts